<template>
  <div class="d-flex flex-wrap">
    <div
      v-for="(item, index) in filterList"
      :key="index"
      :class="$vuetify.breakpoint.xsOnly ? 'mr-16 pr-10' : 'mr-5'"
    >
      <v-checkbox
        v-model="checked"
        :value="item.value"
        class="checkbox"
        hide-details
        @change="$emit('input', $event)"
      >
        <template slot="label">
          <IconPlanning :name="item.value" width="17" height="17" class="mr-1"/>
          {{ item.text }}
        </template>
      </v-checkbox>
    </div>
  </div>
</template>

<script>
import IconPlanning from "components/icons/planning/IconPlanning";

export default {
  name: "PlanningTableWorkFilter",
  components: {IconPlanning},
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data: () => ({
    checked: []
  }),
  computed: {
    t() {
      return this.localStorage.translations.pages.projects_status.status
    },
    filterList() {
      return [
        {
          text: this.t['predvaritelnyy'] || '',
          value: 'creating',
        },
        {
          text: this.t['beginer'] || '',
          value: 'intro',
        },
        {
          text: this.t['tsenopredlozhenie'] || '',
          value: 'bidding',
        },
        {
          text: this.t['ne-sostoyavshiysya'] || '',
          value: 'canceled',
        },
        {
          text: this.t['v-ozhidanii'] || '',
          value: 'pending',
        },
        {
          text: this.t['v-rabote'] || '',
          value: 'in_progress',
        },
        {
          text: this.t['zavershen'] || '',
          value: 'done',
        },
      ]
    },
  },
  created() {
    this.checked = this.value
  },
}
</script>

<style scoped lang="scss">
.v-input {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
